import {useEffect, useState} from "react";
import {Clock} from "@/class/Clock.ts";
import {useTimeZone} from "@/hooks/useTimeZone.tsx";
import {useFormat} from "@/hooks/useFormat.tsx";

/**
 * Hook personnalisé qui fournit l'heure et la date formatées.
 *
 * Retourne:
 *  - isEn : boolean indiquant si le format est anglais ("en-EN")
 *  - timer : objet contenant le format jour/heure (issu de Clock.dayFormat)
 *  - date : chaîne représentant la date formatée (issu de Clock.dateString)
 *  - format : chaîne du format courant (ex: "en-EN")
 */
export function useTimer() {
    const { format } = useFormat()
    const { timeZone } = useTimeZone()

    const [timer, setTimer] = useState({
        ...new Clock().dayFormat
    })

    const [date, setDate] = useState(new Clock().dateString)

    useEffect(() => {
        /**
         * Met à jour le timer et la date toutes les 100ms.
         * On reconstruit Clock avec le format et le fuseau pour recalculer les valeurs.
         */
        const interval = setInterval(() => {
            setTimer(new Clock(format, timeZone).dayFormat)
            setDate(new Clock(format, timeZone).dateString)
        }, 100)

        return () => clearInterval(interval)
    }, [format, timeZone]);

    return {
        isEn: format === "en-EN", timer, date, format
    }
}